import { v4 as uuidv4 } from "uuid";

const dataSlider = [
  {
    id: uuidv4(),
    title: "Robot Dance",
    price: "1799.99"
  },
  {
    id: uuidv4(),
    title: "Lorem ipsum",
    price: "1799.99"
  },
  {
    id: uuidv4(),
    title: "Lorem ipsum",
    price: "1799.99"
  },
  {
    id: uuidv4(),
    title: "Lorem ipsum",
    price: "1799.99"
  },
];

export default dataSlider;